interface IconLinkedInProps extends React.ComponentProps<"svg"> {}

export const IconLinkedIn: React.FC<IconLinkedInProps> = (props) => {
  return (
    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M18.8106 0.598633H1.56942C0.743516 0.598633 0.0756836 1.25066 0.0756836 2.0568V19.3691C0.0756836 20.1752 0.743516 20.8312 1.56942 20.8312H18.8106C19.6365 20.8312 20.3082 20.1752 20.3082 19.373V2.0568C20.3082 1.25066 19.6365 0.598633 18.8106 0.598633ZM6.07827 17.8398H3.075V8.18189H6.07827V17.8398ZM4.57664 6.86598C3.61243 6.86598 2.83395 6.0875 2.83395 5.12725C2.83395 4.16699 3.61243 3.38851 4.57664 3.38851C5.53689 3.38851 6.31537 4.16699 6.31537 5.12725C6.31537 6.08355 5.53689 6.86598 4.57664 6.86598ZM17.3168 17.8398H14.3175V13.1452C14.3175 12.0269 14.2977 10.5845 12.7566 10.5845C11.1957 10.5845 10.9586 11.8056 10.9586 13.0662V17.8398H7.96322V8.18189H10.84V9.50175H10.8796C11.2787 8.74303 12.2587 7.94084 13.7169 7.94084C16.7557 7.94084 17.3168 9.94038 17.3168 12.5406V17.8398Z"
        fill="currentColor"
      />
    </svg>
  );
};

IconLinkedIn.displayName = "IconLinkedIn";
